import { render } from "./MainComp.vue?vue&type=template&id=1d54e3f1"
import script from "./MainComp.vue?vue&type=script&lang=js"
export * from "./MainComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__